'use client';

import { Center, PinInput, Stack, Text } from '@mantine/core';
import { useCallback, useRef } from 'react';

import { formatPhoneNumber } from '@/utils/formatPhoneNumber';

import styles from './OtpInput.module.css';

interface OtpInputProps {
  phoneNumber: string;
  otpCode: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  onSubmit?: () => void;
  autoFocus: boolean;
}

const OtpInput = ({
  phoneNumber,
  otpCode,
  onChange,
  onSubmit,
  disabled = false,
  autoFocus = false,
}: OtpInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = useCallback(
    (value: string) => {
      onChange(value);

      // Auto-submit when all 6 digits are entered
      if (value?.length === 6 && onSubmit) {
        setTimeout(() => {
          onSubmit();
        }, 300);
      }
    },
    [onChange, onSubmit],
  );

  return (
    <Stack gap="md">
      <Text
        variant="small"
        ta="center"
      >
        Enter verification code sent to {formatPhoneNumber(phoneNumber)}
      </Text>

      <Center>
        <PinInput
          oneTimeCode
          type="number"
          length={6}
          value={otpCode}
          onChange={handleChange}
          disabled={disabled}
          ref={inputRef}
          autoFocus={autoFocus}
          classNames={{
            root: styles.pinInputRoot,
            pinInput: styles.pinInputInput,
            input: styles.pinInputInput,
          }}
        />
      </Center>
    </Stack>
  );
};

export { OtpInput };
